import React from 'react';
import { Flex, Typography, theme } from 'antd';

const { Title, Text } = Typography;

interface PageHeaderProps {
  /** Page icon shown before the title in the primary colour. */
  icon: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  /** Primary page actions (create buttons, auto-refresh, …); wrap below the title on narrow screens. */
  actions?: React.ReactNode;
}

/**
 * Title block for top-level list pages: icon + title, a one-line description and right-aligned actions.
 * Detail pages use `DetailPageHeader` instead.
 */
export function PageHeader({ icon, title, description, actions }: PageHeaderProps) {
  const { token } = theme.useToken();

  return (
    <Flex
      justify="space-between"
      align="flex-start"
      wrap="wrap"
      gap={token.marginMD}
      style={{ marginBottom: token.marginLG }}
    >
      <div style={{ flex: '1 1 280px', minWidth: 0 }}>
        <Title level={2} style={{ margin: 0, display: 'flex', alignItems: 'center', gap: token.marginSM }}>
          <span style={{ color: token.colorPrimary, display: 'inline-flex' }}>{icon}</span>
          <span style={{ minWidth: 0 }}>{title}</span>
        </Title>
        {description ? (
          <Text type="secondary" style={{ display: 'block', marginTop: token.marginXXS }}>
            {description}
          </Text>
        ) : null}
      </div>
      {actions ? (
        <Flex wrap="wrap" gap={token.marginXS} align="center" style={{ flex: '0 1 auto', maxWidth: '100%' }}>
          {actions}
        </Flex>
      ) : null}
    </Flex>
  );
}

export default PageHeader;
